import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetRoomsAndStudentsData } from '../types';

export const GET_ROOMS_AND_STUDENTS: TypedDocumentNode<IGetRoomsAndStudentsData> = gql`
  query getRoomsAndStudents {
    viewer {
      id
      site {
        id
        rooms {
          id
          groupTypes
          title
        }
        students {
          # absent
          candDOB
          candFirstName
          candLastName
          candRegNo
          candMidInit
          # deniedEntry
          displayedRegNo
          groupType
          id
          multiDayInd
          room {
            id
            title
          }
          testPackageCount
          testPackageSeq
          accommodationsArray {
            code
            supplementalInfo
          }
        }
      }
    }
  }
`;
